import React, { useContext } from 'react';
import { get, isArray, isNumber } from '@libs/shared';
import { PLUGIN_ARGUMENT_FIELD_TYPE, PLUGIN_ARGUMENT_VALUE_FROM } from '../../../interfaces';
import { PluginComponentContext } from '../plugin-component';
import FieldVariableSelect from '../field-variable-select';
import Number from '../../../components/number';

/**
 * 插件-数字字段
 */
const PluginNumber = () => {
    const pluginComponentStore = useContext(PluginComponentContext);

    if (!pluginComponentStore) {
        return null;
    }

    const { field, fieldValue, isView, checkStatusVisible, onChange } = pluginComponentStore;

    const renderContext = () => {
        const selectType = get(fieldValue, 'resolver_type', PLUGIN_ARGUMENT_VALUE_FROM.LITERAL);
        const { isRequired, isEnabled } = field;
        const value = fieldValue.resolver_arg;

        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.LITERAL) {
            return (
                <Number
                    inputState={checkStatusVisible && isRequired && !value ? 'error' : undefined}
                    disabled={!isEnabled}
                    readonly={isView}
                    value={isNumber(value) ? value : undefined}
                    onChange={(v) => {
                        onChange(v);
                    }}
                />
            );
        }
        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.PROCESS_VAR) {
            return (
                <FieldVariableSelect
                    value={isArray(value) ? value : undefined}
                    argumentType={PLUGIN_ARGUMENT_FIELD_TYPE.NUMBER}
                />
            );
        }
    };

    return <div className="fx-plugin-number">{renderContext()}</div>;
};

export default PluginNumber;
